export default __webpack_public_path__ + "static/media/email.84b4d959.svg";